<template>
  <ActionIcon
    v-if="authUser.permission.canAccessInboxInOverview && hasEstateAccount"
    icon="messages"
    tooltip-position="is-top"
    :tooltip="tooltip"
    :action-fn="onClick"
    :badge-content="badgeContent"
  />
</template>

<script>
import { getters } from '@/modules/core/app/helpers/store';
import { Estate } from '@/modules/estate/models/Estate';
import ActionIcon from '@/modules/core/app/components/ActionIcon.vue';
import { HasAuthUserMixin } from '@/modules/core/app/mixins/HasAuthUserMixin';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'SpotlightEstateInboxAction',
  emits: ['on-inbox-click'],
  mixins: [HasAuthUserMixin],
  components: {
    ActionIcon
  },
  props: {
    estate: Estate
  },
  computed: {
    badgeContent() {
      return this.conversations[this.estate.id] && this.conversations[this.estate.id].length;
    },
    conversations() {
      return getters.inbox.getUnreadConversationsByEstate();
    },
    tooltip() {
      return this.$t('estate.go-to-inbox');
    },
    hasEstateAccount() {
      return this.estate.estateAccounts.some((ea) => ea.userId === this.authUser.id);
    }
  },
  methods: {
    onClick() {
      this.$emit('on-inbox-click', this.estate.id);
    }
  }
};
</script>
